import React, { useState, useEffect } from "react";
import style from "./Navbar.module.css";
import logo from "../../../../Assets/img/logo.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import InstagramIcon from "@mui/icons-material/Instagram";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineDot from "@material-ui/lab/TimelineDot";

import progress1 from "../../../../Assets/img/progress1.png";

import progress2B from "../../../../Assets/img/progress2B.png";
import progress3 from "../../../../Assets/img/progress3.png";
import progress4 from "../../../../Assets/img/progress4.png";
import progress5 from "../../../../Assets/img/progress5.png";
import { Link, useMediaQuery } from "@material-ui/core";

export const Navbar = () => {
  const mobile = useMediaQuery("(max-width:768px)");

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  let value1 = 649;

  let value2 = 1299;

  let value3 = 1948;

  let value4 = 2598;

  return (
    <div className={!mobile ? style.container : style.containerMob}>
      <div className={!mobile ? style.item1 : style.item1Mob}>
        <img
          src={logo}
          alt="logo"
          className={!mobile ? style.mainLogo : style.mainLogoMob}
        />

        <div className={style.dotGroup}>
          <div className={style.dot1}></div>
          <div className={style.dot2}></div>
          <div className={style.dot3}></div>
          <div className={style.dot4}></div>
          <div className={style.dot5}></div>
          <div className={style.dot6}></div>
          <div className={style.dot7}></div>
        </div>
      </div>
      {!mobile ? (
        <div className={style.item2}>
          <a href="#conocenos" className={style.Links}>
            Conócenos{" "}
          </a>
          <a href="#Submarcas" className={style.Links}>
            Submarcas{" "}
          </a>
          <a href="#Servicios" className={style.Links}>
          ¿Por qué Visnú?{" "}
          </a>
          <a href="#Contacto" className={style.Links}>
            Contacto{" "}
          </a>
        </div>
      ) : (
        ""
      )}

      {!mobile ? (
        <div className={style.item3}>
          <div className={style.socialCont}>
            <Link
              rel="noopener noreferrer"
              href=" https://wa.me/50242371621"
              target="_blank"
            >
              {" "}
              <WhatsAppIcon className={style.socialIcon}></WhatsAppIcon>{" "}
            </Link>

            <Link
              rel="noopener noreferrer"
              href=" https://www.facebook.com/visnunatura/"
              target="_blank"
            >
              <FacebookIcon className={style.socialIcon}></FacebookIcon>
            </Link>

            <Link
              rel="noopener noreferrer"
              href=" https://www.instagram.com/visnunatura/"
              target="_blank"
            >
              <InstagramIcon className={style.socialIcon}></InstagramIcon>
            </Link>

            <Link
              rel="noopener noreferrer"
              href=" mailto:info@visnu.com.gt"
              target="_blank"
            >
              {" "}
              <MailOutlineIcon className={style.socialIcon}></MailOutlineIcon>
            </Link>
          </div>
        </div>
      ) : (
        <WhatsAppIcon className={style.socialIconMob}></WhatsAppIcon>
      )}

      {!mobile ? (
        <Timeline className={style.timeLine}>
          <TimelineItem>
            <TimelineSeparator>
              {scrollPosition < value1 ? (
                <TimelineDot className={style.dotTransp}>
                  <img src={progress1} alt="" />
                </TimelineDot>
              ) : (
                <TimelineDot variant="outlined" />
              )}
              <TimelineConnector />
            </TimelineSeparator>
          </TimelineItem>
          <TimelineItem>
            <TimelineSeparator>
              {scrollPosition > value1 && scrollPosition < value2 ? (
                <TimelineDot className={style.dotTransp}>
                  {" "}
                  <img src={progress2B} alt="" className={style.img2} />
                </TimelineDot>
              ) : (
                <TimelineDot variant="outlined" />
              )}
              <TimelineConnector />
            </TimelineSeparator>
          </TimelineItem>
          <TimelineItem>
            <TimelineSeparator>
              {scrollPosition > value2 && scrollPosition < value3 ? (
                <TimelineDot className={style.dotTransp}>
                  <img src={progress3} alt="" />
                </TimelineDot>
              ) : (
                <TimelineDot variant="outlined" />
              )}
              <TimelineConnector />
            </TimelineSeparator>
          </TimelineItem>
          <TimelineItem>
            <TimelineSeparator>
              {scrollPosition > value3 && scrollPosition < value4 ? (
                <TimelineDot className={style.dotTransp}>
                  <img src={progress4} alt="" />
                </TimelineDot>
              ) : (
                <TimelineDot variant="outlined" />
              )}
              <TimelineConnector />
            </TimelineSeparator>
          </TimelineItem>
          <TimelineItem>
            <TimelineSeparator>
              {scrollPosition > value4 ? (
                <TimelineDot className={style.dotTransp}>
                  <img src={progress5} alt="" />
                </TimelineDot>
              ) : (
                <TimelineDot variant="outlined" />
              )}
            </TimelineSeparator>
          </TimelineItem>
        </Timeline>
      ) : (
        ""
      )}
    </div>
  );
};
